import styled, { css } from 'styled-components'

export const HeaderWrapper = styled.div`
  ${({ theme }) => css`
    margin-top: 30px;
    width: auto;
    padding: 2em 2em 2em 2em;
    background-color: ${theme.ds.colors.white};
    border-radius: ${theme.border.radius.small};
    border: 1px solid ${theme.ds.colors.neutral200};
  `}
`

export const ContentWrapper = styled.div`
  margin-top: 30px;
  overflow-y: hidden;
`

export const TopContainer = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 30px;

  .btn-generate-pendency {
    width: 100%;
  }
`

export const ColumnsContainer = styled.div`
  height: 100%;
  display: flex;
  justify-content: space-between;
  overflow-y: hidden;
`

export const LeftContainer = styled.div`
  min-width: 460px;
  max-width: 460px;
  flex: 1;
  overflow-y: scroll;
  width: 100%;
  height: 100%;
  min-height: calc(100% + 5px);
`

export const CenterContainer = styled.div`
  padding-top: 40px;
  flex: auto;
  height: 100%;
  width: 100%;
`

export const RightContainer = styled.div`
  padding-top: 40px;
  max-width: 310px;
  min-width: 370px;
  height: 100%;
`

export const ComentFlexContainer = styled.div`
  border-left: 1px solid ${({ color }) => color};
  display: flex;
  padding: 12px 10px;
  align-items: center;
  margin: 15px 0;

  span {
    color: ${({ theme }) => theme.ds.colors.neutral600};
  }
`

export const StatusTag = styled.div<any>`
  width: auto;
  height: auto;
  margin: 0;
  padding: 0 2px;

  display: flex;
  justify-content: center;

  background: ${({ color }) => color};
  border-radius: 24px;
  color: #fff;

  span {
    font-style: normal;
    font-weight: ${({ theme }) => theme.ds.typography.weight.semiBold};
    font-size: ${({ theme }) => theme.ds.typography.size.xsmall};
    line-height: 28px;
    display: flex;
    align-items: center;
    text-align: center;
    color: ${(props) => props.tagLabel};

    padding: 0 5px;
  }
`
export const CardHeader = styled.div`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  margin-bottom: 8px;
  gap: 24px;
`

export const ProcedureTextWrapper = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: flex-start;
`

export const InfoContainer = styled.div`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  margin-top: 32px;
  gap: 24px;
`

export const SurgeryTitle = styled.h1`
  font-style: normal;
  font-weight: ${({ theme }) => theme.font.bold};
  font-size: ${({ theme }) => theme.font.sizes.large};
  line-height: 48px;
  color: ${({ theme }) => theme.colors.brightOrange};
  flex: none;
  margin-bottom: 24px;
`
export const Strong = styled.strong`
  display: flex;
  align-items: center;
  color: ${({ theme }) => theme.colors.gray};
  font-weight: ${({ theme }) => theme.font.bold};
  font-size: ${({ theme }) => theme.font.sizes.medium};
  line-height: 28px;
`

export const StrongTitle = styled.strong`
  display: flex;
  align-items: center;
  color: ${({ theme }) => theme.ds.colors.neutral900};
  font-weight: ${({ theme }) => theme.font.bold};
  font-size: ${({ theme }) => theme.ds.typography.size.medium};
  line-height: 28px;
  margin-right: 20px;
`

export const SubTitle = styled.label`
  display: flex;
  align-items: center;
  color: ${({ theme }) => theme.ds.colors.neutral900};
  font-size: ${({ theme }) => theme.font.sizes.small};
  font-weight: ${({ theme }) => theme.font.bold};
  line-height: 28px;
`

export const GreenLabel = styled.h2`
  color: ${({ theme }) => theme.colors.primary};
  font-size: ${({ theme }) => theme.font.sizes.large};
  font-weight: ${({ theme }) => theme.font.semiBold};
  line-height: 32px;
  margin-bottom: 20px;
`

export const TextDescription = styled.span`
  color: ${({ theme }) => theme.colors.gray};
  font-size: ${({ theme }) => theme.font.sizes.xsmall};
  font-weight: ${({ theme }) => theme.font.normal};
  margin: 3px 0 3px 0;
`

export const TagDescription = styled.span`
  color: ${({ theme }) => theme.ds.colors.neutral700};
  font-size: ${({ theme }) => theme.ds.typography.size.xsmall};
  font-weight: ${({ theme }) => theme.font.semiBold};
`

export const Ball = styled.div<any>`
  border-radius: 8px;
  background: ${({ theme, colorBall }) =>
    colorBall || theme.ds.colors.primary600};
  width: 12px;
  height: 12px;
  color: ${({ theme }) => theme.ds.colors.primary600};
`

export const BallCounter = styled.div`
  border-radius: 25px;
  background: ${({ color }) => color};
  width: 36px;
  height: 36px;
  color: ${({ theme }) => theme.ds.colors.white};
  font-size: ${({ theme }) => theme.ds.typography.size.medium};
  font-weight: ${({ theme }) => theme.font.semiBold};
  display: flex;
  justify-content: center;
  align-items: center;
`

export const OrderContainer = styled.div`
  ${({ theme }) => css`
    max-width: 1168px;
    width: auto;
    height: auto;
    margin: auto;
    padding: 0em 0 1em 0;
    background-color: ${theme.colors.white};
    display: block;
  `}

  textarea {
    border: 1px solid ${({ theme }) => theme.colors.softGray};
  }

  .text {
    border: 1px solid ${({ theme }) => theme.colors.softGray};
  }

  hr {
    margin-top: 12px;
    margin-bottom: 12px;
    border: 0;
    height: 0;
    border-top: 1px #dadee2;
    border-bottom: 1px solid #dadee2;
  }
`

export const LabelStrong = styled.label`
  color: ${({ theme }) => theme.colors.black};
  font-size: ${({ theme }) => theme.font.sizes.xsmall};
  font-weight: ${({ theme }) => theme.ds.typography.weight.bold};
  display: flex;
`

export const CheckboxWrapper = styled.div`
  display: flex;
  margin-bottom: 8px;
`

export const ProfileWrapper = styled.div`
  display: grid;
  grid-template-columns: 3fr 1.3fr;
  gap: 63px;
`

export const Title = styled.h5`
  ${({ theme }) => css`
    font-size: ${theme.font.sizes.large};
    font-weight: 400;
    color: ${theme.colors.gray};
    cursor: pointer;
  `}
`

export const ModalTitle = styled.h3`
  font-size: ${({ theme }) => theme.font.sizes.small};
  font-weight: ${({ theme }) => theme.font.bold};
  color: ${({ theme }) => theme.colors.neutralBlack};
`

export const FlexContainer = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
  gap: 8px 24px;
  justify-content: flex-end;
`

export const CardHeaderFlexContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`

export const TagContainer = styled.div`
  display: flex;
  align-items: center;
  flex-shrink: 0;
  gap: 4px;
`

export const Separator = styled.div`
  width: 2px;
  /* height: 572px; */
  height: 100%;
  margin: 0 18px;
  background-color: ${({ theme }) => theme.ds.colors.neutral200};
  margin-top: 40px;
  /* justify-self: flex-end;
  align-self: flex-end; */
`

export const EventHeader = styled.div`
  display: flex;
  margin-bottom: 20px;
  font-size: ${({ theme }) => theme.ds.typography.size.xsmall};
`

export const HistoryItem = styled.div`
  display: grid;
  margin-bottom: 20px;
`

export const HistoryContainer = styled.div`
  overflow-y: scroll;
  padding: 0 10px;
  height: 330px;
  margin-bottom: 25px;
`

export const HistoryMessage = styled.span`
  color: ${({ theme }) => theme.ds.colors.neutral900};
  font-size: ${({ theme }) => theme.ds.typography.size.xsmall};
`

export const PendencyAuthorContainer = styled.span`
  display: flex;
  gap: 8px;
  div {
    display: grid;
  }
`

export const AuthorMessage = styled.span`
  color: ${({ theme }) => theme.ds.colors.neutral900};
  font-weight: ${({ theme }) => theme.ds.typography.weight.bold};
  font-size: ${({ theme }) => theme.ds.typography.size.xxsmall};
  margin-bottom: 1px;
`

export const CircleSeparator = styled.span`
  width: 3px;
  height: 3px;
  background-color: ${({ theme }) => theme.ds.colors.primary200};
  border-radius: 50%;
  display: inline-block;
  margin-bottom: 3px;
`
export const MessageDate = styled.span`
  color: ${({ theme }) => theme.ds.colors.neutral600};
  font-weight: ${({ theme }) => theme.ds.typography.weight.bold};
  font-size: ${({ theme }) => theme.ds.typography.size.xxsmall};
  margin-bottom: 8px;
`

export const RelativeTimeText = styled.span`
  color: ${({ theme }) => theme.ds.colors.primary600};
  font-weight: ${({ theme }) => theme.ds.typography.weight.bold};
  font-size: ${({ theme }) => theme.ds.typography.size.xsmall};
  line-height: 8px;
`

export const MessageSendByText = styled.span`
  color: ${({ theme }) => theme.ds.colors.neutral600};
  font-weight: ${({ theme }) => theme.ds.typography.weight.bold};
  font-size: ${({ theme }) => theme.ds.typography.size.xsmall};
`
export const MessageSendBy = styled.div`
  margin-left: auto;
`

export const ButtonPanel = styled.div`
  display: flex;
  max-width: 700px;
  justify-content: space-between;
  gap: 10px;
  margin-top: 35px;
  margin-left: auto;
  button {
    width: 45%;
  }
`

export const StatusButtonPanel = styled.div`
  display: flex;
  max-width: 700px;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 35px;
  margin-left: auto;
  button {
    width: 25%;
  }
`

export const PatientControlPanel = styled.div`
  margin-top: 20px;
  display: flex;
  flex-direction: column;
  gap: 30px;
`

export const ModalInfo = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
`

export const AlertIconWrapper = styled.span`
  display: flex;
  svg {
    width: 24px;
    height: 24px;
    path {
      fill: ${({ theme }) => theme.ds.colors.danger500};
    }
  }
`

export const FlexGap = styled.div`
  display: flex;
  gap: 8px;

  svg {
    path {
      fill: ${({ theme }) => theme.ds.colors.primary600};
    }
  }
`
export const Underscore = styled.p`
  color: ${({ theme }) => theme.ds.colors.primary600};
  font-weight: 500;
  text-decoration: underline;
  cursor: pointer;
`

export const OtherSurgeriesContainer = styled.div`
  margin-left: auto;
  margin-right: 32px;
  display: flex;
  flex-direction: column;
  gap: 4px;
`

export const CardContainer = styled.div`
  gap: 15px;
  padding: 8px 15px 8px;
  margin-bottom: 8px;
  ${({ theme }) => css`
    &:hover {
      background-color: ${theme.ds.colors.primary50};

      p {
        color: ${theme.ds.colors.primary600};
      }

      .order {
        font-weight: 550;
      }
      .doctor {
        font-weight: 550;
      }
      .unit {
        font-weight: 550;
      }
    }
  `};
`

export const OtherSurgeriesWrapper = styled.div`
  width: 300px;
  margin-top: 5px;
  left: 63%;
  transform: translate(-4%);
  position: absolute;
  background-color: white;
  box-shadow: 0px 4px 9px 2px rgba(0, 0, 0, 0.25);
  border-radius: 8px;
`

export const OtherSurgeriesScroll = styled.div`
  height: 300px;
  overflow-y: scroll;
`

export const CreatedByContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`

export const CreatedByProfile = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  width: 26px;
  height: 26px;
  font-size: ${({ theme }) => theme.ds.typography.size.xsmall};
  color: ${({ theme }) => theme.ds.colors.white};
  font-weight: ${({ theme }) => theme.ds.typography.weight.bold};
  background-color: ${({ theme }) => theme.ds.colors.primary400};
  border: 1px solid ${({ theme }) => theme.ds.colors.neutral100};
  flex-shrink: 0;
`
